import { render, staticRenderFns } from "./TaxOutstanding.vue?vue&type=template&id=35b1f03a"
import script from "./TaxOutstanding.vue?vue&type=script&lang=js"
export * from "./TaxOutstanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports